import { useEffect } from "react";

import Modal from "components/ui/modal";

import drawBonusModalNotificationCanvas from "./helpers/drawBonusModalNotificationCanvas";

import FreeBetView from "./freeBetView";
import useGlobalVariables from "hooks/useGlobalVariables";

const BonusModalNotificationView = ({
	isVisible,
	bonuses,
	handleOnOk,
	...otherProps
}) => {
	const { isMobile } = useGlobalVariables();

	useEffect(() => {
		if (!isVisible) {
			return;
		}

		const modalBackground = document.querySelector(".vs--bonus-notification-modal-outside");
		const canvas = document.createElement("canvas");
		canvas.classList.add("vs--bonus-modal-notification-canvas");
		modalBackground.appendChild(canvas);

		drawBonusModalNotificationCanvas(canvas, modalBackground);

		return () => {
			canvas.classList.remove("vs--bonus-modal-notification-canvas");
			canvas.remove();
		};
	}, [isVisible]);

	return (
		<Modal
			coordinates={isMobile ? { clientX: "50vw", clientY: "50vh" } : undefined}
			isOpen={isVisible}
			onCancel={handleOnOk}
			classNames={{ content: "vs--bonus-notification-modal", outside: "vs--bonus-notification-modal-outside" }}
			onOutsideClick={isMobile ? handleOnOk : () => { }}
			closeIcon={null}
		>
			<FreeBetView {...otherProps} bonuses={bonuses}	handleOnOk={handleOnOk} />
		</Modal>
	);
};
export default BonusModalNotificationView;
